import { getMinutes, set } from "date-fns";

const getDefaultStartDate = (): Date => {
  const date = new Date();
  const minutes = getMinutes(date);
  return set(date, { minutes: minutes - (minutes % 5) + 10 });
};

export default getDefaultStartDate;
